import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
	dropZone: {
		border: `2px dashed ${colors.gray[200]}`,
		borderRadius: theme.shape.borderRadius,
		padding: theme.spacing(2, 3),
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		width: "100%",
		cursor: "pointer",
		boxSizing: "border-box",
		transition: "border-color 0.2s, background-color 0.2s",
		"&:hover": {
			borderColor: colors.green[600],
			backgroundColor: colors.green[50]
		}
	},
	dropZoneDragging: {
		borderColor: colors.green[600],
		backgroundColor: colors.green[50]
	},
	dropZoneLeft: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(2)
	},
	dropZoneIcon: {
		color: colors.gray[300],
		fontSize: 36
	},
	dropZoneTextPrimary: {
		fontWeight: 600,
		color: colors.gray[800],
		fontSize: 14
	},
	dropZoneTextSecondary: {
		color: colors.gray[400],
		fontSize: 12
	},
	selectButton: {
		backgroundColor: colors.green[100],
		color: colors.green[700],
		fontWeight: 600,
		whiteSpace: "nowrap",
		textTransform: "none",
		"&:hover": {
			backgroundColor: colors.green[200]
		}
	},
	selectedRow: {
		backgroundColor: colors.green[50],
		border: `1px solid ${colors.green[200]}`,
		borderRadius: theme.shape.borderRadius,
		padding: theme.spacing(1.5, 2),
		display: "flex",
		alignItems: "center",
		width: "100%",
		boxSizing: "border-box"
	},
	selectedFileIcon: {
		color: colors.green[600],
		fontSize: 36,
		marginRight: theme.spacing(2),
		flexShrink: 0
	},
	selectedFileInfo: {
		flex: 1,
		overflow: "hidden"
	},
	selectedFileName: {
		fontWeight: 600,
		color: colors.gray[800],
		fontSize: 14,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis"
	},
	selectedFileMeta: {
		color: colors.gray[500],
		fontSize: 12
	},
	removeButton: {
		color: colors.gray[600],
		fontWeight: 600,
		whiteSpace: "nowrap",
		textTransform: "none",
		"&:hover": {
			backgroundColor: "transparent",
			color: colors.gray[800]
		}
	}
}))

export default useStyles
